export type AppScopeKey = string;
